export default "__VITE_ASSET__Bt8ZstV3__"